operations:
  load-models: Charger Modèle
  load-models-status:
    loading: Chargement
    ready: Prêt
docs:
  theme:
    navbar:
      appearance:
        title: Apparence
'controls-island':
  'fade-on-hover':
    enable: Masquer au survol
    disable: Toujours afficher
  'open-settings': Ouvrir les paramètres
  'open-chat': Ouvrir le Chat
  'refresh': Actualiser
  'open-hearing-controls': Ouvrir les contrôles d'écoute
  'drag-to-move-window': Glisser pour déplacer la fenêtre
  'switch-to-light-mode': Passer au mode clair
  'switch-to-dark-mode': Passer au mode sombre
  'pin-on-top': Épingler en haut
  'unpin-from-top': Désépingler du haut
  'switch-profile': Changer de Profil
  'close': Fermer
  'expand': Développer
  'collapse': Réduire
  'login': Se connecter
  'logging-in': Connexion en cours...
  'account': Compte
  'logout': Compte
notice:
  'fade-on-hover':
    title: Disparaître au survol
    intro: Fait disparaître légèrement le personnage quand le curseur s’approche. Moins de distractions tout en restant visible.
    opacity: Une fois activé, l’opacité descend à {value} pour {targets} quand le curseur est à proximité.
    toggle: Vous pouvez le désactiver en survolant l’{controls}, puis en cliquant à nouveau sur l’{icon}.
    controls-label: Îlot de commandes
    icon-label: icône œil barré
    value: '0'
    targets: Personnage et UI
    confirm: Compris
    dont-show-again: Ne plus afficher
    preparing: Préparation…
    read-more: En savoir plus
    preview-title: C’est quoi ?
about:
  subtitle: Desktop ver.
  current-version: Current Version
  common:
    cancel: Cancel
  links:
    title: Links
    home: Home
    documentation: Documentations
    github: GitHub
  update:
    lane:
      label: Update lane
      description: Choose channel release to follow
      placeholder: Choose update lane
    channels:
      auto: Auto
      stable: Stable
      alpha: Alpha
      beta: Beta
      nightly: Nightly
      canary: Canary
    status:
      downloading: Downloading update...
      error-prefix: Error
      latest: Up to date (v{version}).
      downloaded:
        windows: Update ready to install silently (v{version}).
        restart: Update ready to install on restart (v{version}).
    actions:
      download: Download Update
      download-short: Download
      confirm-download: Confirm Download
      check-for-updates: Check for updates
      checking: Checking...
      latest-version: Latest version
      disabled-dev: Updates disabled in Dev
      retry-check: Retry Check
      restart-silent: Restart to update silently
      restart-install: Restart to install update
      confirm-restart: Confirm Restart
    dialog:
      title: Update Available
      description: A new version (v{version}) is available.
      no-release-notes-markdown: _No release notes provided._
